import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const fetchSuiteAssetAreasDone = (_, { payload }) => {
    return [
      ...payload,
    ]
  };

  /*
    Created By: Sai Prasad
    Created Date: 12/09/2022
    Ticket: 3209
    Description: function to clear redux state suite areas.
*/
  const clearSuiteAssetAreasDone = () => {
    return [];
  }
  const initialState = [];
  export default createReducer(initialState, {
    [TYPES.FETCH_SUITE_ASSET_AREAS_DONE] : fetchSuiteAssetAreasDone,
    [TYPES.CLEAR_SUITE_ASSET_AREAS_DONE] : clearSuiteAssetAreasDone
  });